export const contactReason = {
    'en': [
        { name: 'I would like to buy a property', value: 'buy' },
        { name: 'I would like to rent a property', value: 'rent' },
        { name: 'Landlord wishing to sell/rent property', value: 'sell' },
        { name: 'Other enquiry or question', value: 'other' }
    ],
    'cn': [
        { name: '我想买房', value: 'buy' },
        { name: '我想租房', value: 'rent' },
        { name: '业主委托出售/出租', value: 'sell' },
        { name: '其他咨询 or 问题', value: 'other' }
    ],
    'th': [
        { name: 'ฉันต้องการซื้ออสังหาริมทรัพย์', value: 'buy' },
        { name: 'ฉันต้องการเช่าอสังหาริมทรัพย์', value: 'rent' },
        { name: 'เจ้าของอสังหาฯ ที่ต้องการฝากขาย/เช่า', value: 'sell' },
        { name: 'สอบถามข้อมูลอื่น ๆ หรือมีข้อสงสัย', value: 'other' }
    ],
    'ru': [
        { name: 'Я хочу купить недвижимость', value: 'buy' },
        { name: 'Я хочу арендовать недвижимость', value: 'rent' },
        { name: 'Собственник: хочу продать/сдать в аренду', value: 'sell' },
        { name: 'Другой вопрос или запрос', value: 'other' }
    ],
    'fr': [
        { name: 'Je souhaite acheter un bien', value: 'buy' },
        { name: 'Je souhaite louer un bien', value: 'rent' },
        { name: 'Propriétaire : vendre ou louer mon bien', value: 'sell' },
        { name: 'Autre demande ou question', value: 'other' }
    ],
    'de': [
        { name: 'Ich möchte eine Immobilie kaufen', value: 'buy' },
        { name: 'Ich möchte eine Immobilie mieten', value: 'rent' },
        { name: 'Eigentümer: Verkauf oder Vermietung', value: 'sell' },
        { name: 'Sonstige Anfrage oder Frage', value: 'other' }
    ],
    'it': [
        { name: 'Desidero acquistare un immobile', value: 'buy' },
        { name: 'Desidero affittare un immobile', value: 'rent' },
        { name: 'Proprietario: desidero vendere/affittare', value: 'sell' },
        { name: 'Altre richieste o domande', value: 'other' }
    ],
    'ja': [
        { name: '物件の購入を希望', value: 'buy' },
        { name: '物件の賃貸を希望', value: 'rent' },
        { name: '売却・賃貸を希望されるオーナー様', value: 'sell' },
        { name: 'その他のお問い合わせ・ご質問', value: 'other' }
    ],
    'ko': [
        { name: '매수하고 싶습니다', value: 'buy' },
        { name: '임차하고 싶습니다', value: 'rent' },
        { name: '매도/임대 희망 소유주', value: 'sell' },
        { name: '기타 문의 및 질문', value: 'other' }
    ],
    'es': [
        { name: 'Me gustaría comprar una propiedad', value: 'buy' },
        { name: 'Me gustaría alquilar una propiedad', value: 'rent' },
        { name: 'Propietario: deseo vender/alquilar mi propiedad', value: 'sell' },
        { name: 'Otras consultas o preguntas', value: 'other' }
    ],
    'tr': [
        { name: 'Gayrimenkul satın almak istiyorum', value: 'buy' },
        { name: 'Gayrimenkul kiralamak istiyorum', value: 'rent' },
        { name: 'Mülk sahibi: Satmak/Kiralamak istiyorum', value: 'sell' },
        { name: 'Diğer talep veya sorular', value: 'other' }
    ],
    'he': [
        { name: 'ברצוני לקנות נכס', value: 'buy' },
        { name: 'ברצוני לשכור נכס', value: 'rent' },
        { name: 'בעל נכס המעוניין למכור/להשכיר', value: 'sell' },
        { name: 'בירור אחר או שאלה', value: 'other' }
    ],
    'ar': [
        { name: 'أرغب في شراء عقار', value: 'buy' },
        { name: 'أرغب في استئجار عقار', value: 'rent' },
        { name: 'مالك عقار يرغب في البيع/التأجير', value: 'sell' },
        { name: 'استفسارات أو أسئلة أخرى', value: 'other' }
    ]
}